// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__XoXmM","choiceBoxes":"toolbarselects_choiceBoxes__1BLBF","simpleField":"toolbarselects_simpleField__3VeTb"};